import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { palette, themeMode, spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
var Autocomplete = styled(Box).withConfig({
  componentId: "sc-1w9m0b9-0"
})(["position:relative;"]);
var Divider = styled.div.withConfig({
  componentId: "sc-1w9m0b9-1"
})(["display:none;align-items:center;justify-content:center;color:", ";width:100%;&:not(:last-child){display:flex;}&:after,&:before{content:' ';flex-grow:1;height:1px;background-color:", ";}"], palette("neutral.500"), themeMode({
  light: palette("neutral.200"),
  dark: palette("neutral.700")
}));
var SingleValueComponentContainer = styled(Box).withConfig({
  componentId: "sc-1w9m0b9-2"
})(["display:flex;align-items:center;position:absolute;padding:", ";top:0;left:0;right:0;bottom:0;overflow:hidden;"], spacing("sm"));
var Styled = {
  Autocomplete: Autocomplete,
  Divider: Divider,
  SingleValueComponentContainer: SingleValueComponentContainer
};
export { Styled };